import * as React from 'react';

export const CounterDrugsIcon: React.FunctionComponent = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.77818 3.22182L3.12132 8.87867C1.94975 10.0502 1.94975 11.9497 3.12132 13.1213C4.21967 14.2197 5.9578 14.2883 7.13612 13.3273C7.21468 13.2632 7.29074 13.1945 7.36397 13.1213L13.0208 7.46446C14.1924 6.29289 14.1924 4.39339 13.0208 3.22182C11.8492 2.05025 9.94975 2.05025 8.77818 3.22182ZM9.48529 3.92893L6.65686 6.75735L9.48529 9.58578L12.3137 6.75735C13.0948 5.9763 13.0948 4.70997 12.3137 3.92893C11.5327 3.14788 10.2663 3.14788 9.48529 3.92893ZM3.47488 10.6464C3.27962 10.8417 3.27962 11.1583 3.47488 11.3535C3.67014 11.5488 3.98672 11.5488 4.18199 11.3535L5.5962 9.93933C5.79146 9.74407 5.79146 9.42749 5.5962 9.23223C5.40094 9.03696 5.08435 9.03696 4.88909 9.23223L3.47488 10.6464Z"
        fill="#3A3A3A"
      />
    </svg>
  );
};
